export function omitKeys(
  obj: Record<string, unknown>,
  keys: readonly string[],
): Record<string, unknown> {
  const result: Record<string, unknown> = {};
  for (const key of Object.keys(obj)) {
    if (!keys.includes(key)) {
      result[key] = obj[key];
    }
  }
  return result;
}

export async function cloneVersionResources<T>(
  sourceVersionId: number,
  targetVersionId: number,
  loadFn: (versionId: number) => Promise<T[]>,
  createFn: (data: Partial<T>) => Promise<T>,
  excludeKeys: readonly string[],
): Promise<void> {
  const items = await loadFn(sourceVersionId);
  for (const item of items) {
    const rest = omitKeys(item as unknown as Record<string, unknown>, excludeKeys);
    await createFn({ ...rest, version_id: targetVersionId } as unknown as Partial<T>);
  }
}
